
<template>
  <!--封禁原因-->
  <div>
    <x-tabula
      apiOrigin="PHP"
      ref="table"
      :dataSource="dataSource"
      rowKey="chat_category_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'reasonBan',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '封禁原因', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '应用', options: [], inputType: 'select' }
      ],
      searchParams: {
        keywords: undefined,
        type: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['neighbour:banReason:add'] }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['neighbour:banReason:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), permi: ['neighbour:banReason:delete'] }
      ],
      columns: [
        { title: '封禁原因', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用位置', dataIndex: 'type_desc', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/chat/category/forbidden',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addBanReason',
        addTitle: '新增封禁原因',
        editTitle: '修改封禁原因'
      },
      deleteParam: {
        url: '/chat/category/forbidden',
        param: {pk_key: 'chat_category_id', pk_val: ''},
        title: '封禁原因',
        key: 'title'
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this._get({
        url: '/chat/category/forbidden_select',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data.type;
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>
